"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageView = void 0;
const react_1 = __importDefault(require("react"));
const ImageView = (props) => {
    const { metaUrlBase, metadata } = props;
    const previewImageUrl = metaUrlBase + metadata.image;
    return react_1.default.createElement("img", { src: previewImageUrl });
};
exports.ImageView = ImageView;
